/* eslint-disable no-debugger */
import { API_NAMES, initApi } from '../../utils/HttpApiHelper';
import { BASIC_INITIAL_STATE } from '../../utils/HttpHelper';

const getOrgUnitByOrgUnitIdData = (orgUnitId, state, setState) => {
  const api = initApi(API_NAMES.COMMON, state, setState);

  const orgUnitIdForUrl = orgUnitId ? encodeURIComponent(orgUnitId) : 0;
  const url = `/OrgUnit/${orgUnitIdForUrl}`;
  return api?.executeObject ? api.executeObject(url, 'GET') : null;
};

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const OrgUnitData = {
  INITIAL_STATE: { ...INITIAL_STATE },
  getOrgUnitByOrgUnitIdData
};

export default OrgUnitData;